import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import { DARKER, PRIMARY } from '../../const/colors';
import { mobile_normal } from '../../const/fonts';
import ErrorContainer from './ErrorContainer';
import axios from 'axios';
import {API_URL} from '../../const/api';
import { useSelector } from 'react-redux';
import { selectDetectedCountry } from '../../features/user/userSlice';
import { countries } from '../../const/countries';

const Container = styled.div`
	position: relative;
  flex:1;
	width: 100%;
  margin: 0.5rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
	> select {
		border: 1px solid ${PRIMARY};
		outline: none;
		background-color: transparent;
		color: #888;
		padding: 0.7rem 1rem;
		font-size: 1rem;
		width: 100%;
    transition: all 0.3s ease;
	}
  
	 label {
    font-size: 1rem;
		padding: 0 1rem;
    font-weight: bold;
		color: #fff;
	}

	&:hover {
		select {
			border-color: #fff;
		}
	}

  option {
    background-color: ${DARKER};
    color: #fff;
  }
  @media screen and (max-width: 2000px) {
	  width: 100%;
    select, label {
      font-size: 0.8rem;
      margin: 0.2rem 0;
    }
  }

  @media screen and (max-width: 1600px) {
    margin: 0.25rem 1rem;
  }

  @media screen and (max-width: 768px) {
    align-items: center;
    label {
      font-size: 0.9rem;
    }
    select{
      color:white;
      text-align:justify;
      font-weight: bold;
      font-size:14px;
    }
    margin: 1rem auto;
    text-align: center;
  }

  > select.error {
    border-color: #C21010;
  }
  > select.correct {
    border-color: #28a745;
  }
`;

const SelectBox = ({val, placeholder, label, handleChange, handleBlur, name, error}) => {
  const [focused, setFocused] = useState(false);
  const [monedas, setMonedas] = useState([]);
  const detectedCountry = useSelector(selectDetectedCountry);

  const handleFocus = (e) => {
    handleBlur(e);
    setFocused(true);
  };

  useEffect(()=>{
    const loadData = async () => {
      const res = await axios.post(API_URL+'loadMonedaSignIn', {});
      if(res.data.status===1) {
        let monedasByCountry = countries.find(x=>x.flag===detectedCountry)
        if(monedasByCountry) {
          setMonedas(monedasByCountry.currencies)
        } else {
          setMonedas(res.data.response);
        }
        
      }
    }

    loadData();
  },[]);

  return (
    <Container>
      <label>{label}</label>
      <select
        value={val} 
        onChange={handleChange}
        onBlur={handleFocus}
        placeholder={placeholder} 
        name={name}
        className={error && focused ? 'error' : !error && focused ? 'correct' : null}
        
      >
         <option value="default">{placeholder}</option>
        {monedas && monedas.map(item => {
          if (item.nombre !== "Peso Uruguayo") {
            return <option value={item.simbolo} key={item.id}>{item.nombre}</option>
          }
        })}
      </select>
      {
        (focused && error) && <ErrorContainer focused={focused.toString()} error={error} />
      }
    </Container>
  )
}

export default SelectBox;